<template>
    <div class="xzLoading">
        <dl class="tips">
            <dt><img src="../../../assets/images/normal/xzLoading/logo.png" alt=""></dt>
            <dd>
                <p>即将进入第三方服务页面…</p>
                <p>该服务由<span>合翔保险经纪有限公司</span>提供</p>
            </dd>
        </dl>
        <dl class="notice" v-show="show">
            <dt>
                投米平台作为信息展示平台为合翔保险经纪有限公司（以下简称合翔保险经纪）提供链接跳转等信息展示辅助服务，本智能保险测评页面由合翔保险经纪提供。为更好地为您提供服务，点击确认后您的测评结果会同步给专属服务人员。
            </dt>
            <dd><a href="javascript:void(0)" class="btn" @click="confirm">确认</a></dd>
        </dl>
    </div>
</template>

<script>
    import {callHandler} from "../../../utils/bridge";
    import {request} from "../../../utils/request"

    export default {
        data() {
            return {
                show: false,
                pending: false
            };
        },
        created() {
            const urlParams = this.$route.query;
            const {token} = urlParams;
            this.token = decodeURIComponent(token || "");
            request({
                url: "/h5/xiaozhi/getXiaozhiAuthorize.json",
                data: this.$qs.stringify({
                    token: token
                })
            })
                .then(res => {
                    const {code, data, msg} = res;
                    if (code === '1') {
                        if (data && !data.xiaoZhiAuth) {
                            this.show = true;
                        } else {
                            let timer = setTimeout(function () {
                                clearTimeout(timer);
                                callHandler("xhWapGoBack", "wapCloseWeb");
                            }, 3000)
                        }
                    } else {
                        return Promise.reject(msg)
                    }
                })
                .catch(err => {
                    this.$toast(err);
                });
        },
        methods: {
            confirm() {
                if (this.pending) {
                    return
                }
                this.pending = true;
                request({
                    url: "/h5/xiaozhi/saveXiaozhiAuthorize.json",
                    data: this.$qs.stringify({
                        token: this.token
                    })
                }).then((res) => {
                    this.pending = false;
                    const {code, msg} = res;
                    if (code !== '1') {
                        this.$toast(msg);
                    } else {
                        callHandler("xhWapGoBack", "wapCloseWeb");
                    }
                }).catch(err => {
                    this.pending = false;
                    this.$toast(err);
                });
            }
        }
    };
</script>
<style lang="less">
    body {
        margin: 0;
        background: #ffffff;
    }

    .xzLoading {
        .tips {
            text-align: center;
            padding-top: 140px;

            dt {
                img {
                    width: 209px;
                    height: 40px;
                }
            }

            dd {
                padding-top: 24px;
                line-height: 24px;
                font-size: 14px;
                color: #333333;

                span {
                    color: #C4A06C;
                    margin: 0 6px;
                }
            }
        }

        .notice {
            padding: 32px 16px 0;

            dt {
                color: #c6c6c6;
                font-size: 10px;
                line-height: 14px;
                letter-spacing: -.3px;
                text-align: justify;
            }

            dd {
                padding-top: 26px;

                a {
                    display: block;
                    height: 44px;
                    line-height: 44px;
                    background-image: linear-gradient(90deg, #D0B77B 0%, #B89659 100%);
                    border-radius: 4px;
                    font-size: 16px;
                    color: #FFFFFF;
                    text-align: center;
                }
            }
        }

    }
</style>
